import React from 'react';
import { CardMedia, Box } from '@mui/material';

const ImageCard = ({ 
  src, 
  alt, 
  height = 200, 
  fallbackSrc = '/img/no_media.jpg',
  sx = {} 
}) => {
  const handleImageError = (e) => {
    if (e.target.src !== fallbackSrc) {
      e.target.src = fallbackSrc;
    }
  };

  return (
    <Box sx={{ position: 'relative', width: '100%', height}}>
      <CardMedia
        component="img"
        image={src || fallbackSrc}
        alt={alt}
        onError={handleImageError}
        sx={{
          objectFit: 'contain',
          width: '100%',
          height: '100%',
          backgroundColor: '#f5f5f5',
          ...sx
        }}
      />
    </Box>
  );
};

export default ImageCard;
